import script from "./ExcellenceAndDiscountPromotionClassic.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcellenceAndDiscountPromotionClassic.vue?vue&type=script&setup=true&lang=js"

import "./ExcellenceAndDiscountPromotionClassic.vue?vue&type=style&index=0&id=11483056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11483056"]])

export default __exports__